// Lightweight SEO head manager for the CRA SPA (Phase 5; full QA in Phase 6).
const ORIGIN = 'https://generalharmonics.com';

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function setSeo({ title, description, path = '/', canonical, image = `${ORIGIN}/og-default.jpg`, type = 'website' }) {
  const url = `${ORIGIN}${path}`;
  const canonicalUrl = `${ORIGIN}${canonical || path}`;
  // Only the production domain is indexable; preview/staging is not.
  const isProd = typeof window !== 'undefined' && window.location.hostname === 'generalharmonics.com';
  upsertMeta('name', 'robots', isProd ? 'index, follow' : 'noindex, nofollow');
  if (title) document.title = title;
  if (description) {
    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:description', description);
    upsertMeta('name', 'twitter:description', description);
  }
  if (title) {
    upsertMeta('property', 'og:title', title);
    upsertMeta('name', 'twitter:title', title);
  }
  upsertMeta('property', 'og:type', type);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:image', image);
  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertLink('canonical', canonicalUrl);
}

export function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

// Navigate to the homepage pilot form with a preset category (used from deep routes).
export function goToPilot(category) {
  if (category) {
    try { sessionStorage.setItem('gh_pilot_preset', category); } catch (e) { /* ignore */ }
  }
  window.location.assign('/#pilot');
}
